<template>
<pre class="mt-5" v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            return hljs.highlight(`
$ whoami 

${this.attribute.value}`, { language: 'console' }).value
        }
    }

}
</script>